<template>
    <!-- 对话框 -->
    <el-drawer title="城市信息详情页面" :visible.sync="show" :with-header="false" :before-close="closeDialog" size="600px">
        <!-- 基本信息表单 -->
        <div class="form-box">
            <el-form ref="form">
                <el-form-item label="公司名称:" label-width="125px">
                    {{ data_lists.company.name }}
                </el-form-item>
                <el-form-item label="城市名称:" label-width="125px">
                    {{ data_lists.city.name }}
                </el-form-item>
                <el-form-item label="城市标签:" label-width="125px">
                    {{ data_lists.city_tag }}
                </el-form-item>
                <el-form-item label="负责人:" label-width="125px">
                    {{ data_lists.boss }}
                </el-form-item>
                <el-form-item label="负责人手机号:" label-width="125px">
                    {{ data_lists.phone }}
                </el-form-item>

                <el-form-item label="区域编码:" label-width="125px">
                    {{ data_lists.area_code }}
                </el-form-item>
                <el-form-item label="城市等级:" label-width="125px">
                    {{ data_lists.level.alias }}
                </el-form-item>

            </el-form>

            <!-- 对话框底部按钮 -->
            <div style="display: flex; justify-content: center">
                <el-button @click="open">修改城市信息</el-button>
                <el-button @click="closeDialog">关闭</el-button>
            </div>
        </div>
    </el-drawer>
</template>

<script>
var _this;
export default {
    props: {
        isShow: Boolean,
        data: {}
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;
            _this.data_lists= _this.data
        }
    },
    data() {
        return {
            show: false,
            data_lists: {}

           
        };
    },
    created() {
        _this = this;
    },
    methods: {
        // 关闭方法
        closeDialog() {
            _this.show = false;
         
        },

           open() {
            this.$alert('请联系总经理办公室,获取授权后研发中心将为您进行修改', '', {
                confirmButtonText: '确定',
                callback: (action) => {}
            });
        }
    }
};
</script>

<style scoped>
.form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

.el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
}

.avatar-uploader {
    width: 100px;
    height: 100px;
}
.item-wrap {
    margin-bottom: 10px;
}
</style>
